import BigNumber from 'bignumber.js';
import { GOODS_TYPE, SKUSpecification } from './sku';
import { Order, OrderDeliveryType, OrderSku } from './order';
import { User } from './user';
import { CardUser } from './card';
import { TransactionLog } from './transaction';

export const POS_ENDPOINT = `/pos`;

export interface PosUIConfig {
  coGoodsShowImg: boolean;
  coShowCateIcon: boolean;
  coGoodsNameLines: number;
  coGoodsItemsRow: number;
  coGoodsImgHeight: number;
  coGoodsImgMode: 'cover' | 'contain';
  coSkuAreaDisplayMode: 'vertical' | 'horizontal';
}

export interface POSPaymentRequest {
  authCode: string;
  amount?: number;
}

export interface POSPaymentResponse {
  order: Order;
  user: User;
  skuList: OrderSku[];
  cardUserList: CardUser[];
  transactionList: TransactionLog[];
  /**类型， 支付完成还是服务完成 */
  type?: 'pay' | 'service';
}

export const noopPosPaymentResponse: POSPaymentResponse = {
  order: undefined,
  user: undefined,
  skuList: [],
  transactionList: [],
  cardUserList: [],
};

/**
 * 根据结算商品类型，计算订单的 DeliveryType
 * @param specifications
 * @returns
 */
export const calcSpecificationsDeliveryType = (specifications: SKUSpecification[] | undefined) => {
  if (!specifications) return OrderDeliveryType.INVALID;
  let deliveryType = 0;
  for (const specification of specifications) {
    if (specification.goodsType === GOODS_TYPE.NORMAL) {
      deliveryType |= OrderDeliveryType.IN_STORE_GOODS;
    } else if (specification.goodsType === GOODS_TYPE.SERVICE) {
      deliveryType |= OrderDeliveryType.IN_STORE_SERVICE;
    }
  }
  if (deliveryType === 0) {
    return OrderDeliveryType.INVALID;
  }
  return deliveryType as OrderDeliveryType;
};

export const calcSpecificationsTotalPrice = (specifications: SKUSpecification[] | undefined) => {
  if (!specifications) return new BigNumber(0);

  return specifications.reduce((acc, cur) => {
    return acc.plus(new BigNumber(cur.price).multipliedBy(cur.number));
  }, new BigNumber(0));
};

export const calcSpecificationsTotalNumber = (specifications: SKUSpecification[] | undefined) => {
  if (!specifications) return 0;
  return specifications.reduce((acc, cur) => acc + cur.number, 0);
};
